// Added by Sejune Oh on 2019-09-25
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { makeAutoObservable } from 'mobx'

import Rootstore from '../..'

export default class StudyServiceStore {
    root?: Rootstore
    _totalCount: number = 0

    constructor(rootStore: Rootstore) {
        this.root = rootStore
        makeAutoObservable(this)
    }
}
